import React, { useState, useEffect } from 'react';
import { api } from '../services/api';
import ADFXmlEditor from './ADFXmlEditor';

const DEFAULT_XML_TEMPLATE = `<?xml version="1.0" encoding="UTF-8"?>
<?adf version="1.0"?>
<adf>
  <prospect>
    <requestdate>{{date}}</requestdate>
    <vehicle interest="buy" status="{{vehicle_type}}">
      <year>{{year}}</year>
      <make>{{make}}</make>
      <model>{{model}}</model>
    </vehicle>
    <customer>
      <contact>
        <name part="first">{{lead_first_name}}</name>
        <name part="last">{{lead_last_name}}</name>
        <phone type="cell">{{lead_phone}}</phone>
        <email>{{lead_email}}</email>
      </contact>
      <comments><![CDATA[{{conversation}}]]></comments>
    </customer>
    <vendor>
      <contact>
        <name part="full">{{dealer_name}}</name>
      </contact>
    </vendor>
    <provider>
      <service>ChatIA</service>
      <url><![CDATA[{{source_url}}]]></url>
    </provider>
  </prospect>
</adf>`;

const PresetEditor = ({ presetId, presetData, isNew, onSave, onClose }) => {
  const [id, setId] = useState(presetId || '');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [xmlTemplate, setXmlTemplate] = useState(DEFAULT_XML_TEMPLATE);
  const [migrating, setMigrating] = useState(false);

  useEffect(() => {
    if (presetData) {
      setName(presetData.name || '');
      setDescription(presetData.description || '');

      if (presetData.xml_template) {
        // New format: use xml_template directly
        setXmlTemplate(presetData.xml_template);
      } else if (presetData.mapping) {
        // Old format: convert mapping to xml_template via backend
        setMigrating(true);
        api.post('v1/adf/mapping-to-xml', { mapping: presetData.mapping })
          .then((res) => {
            setXmlTemplate(res.data.xml_template || DEFAULT_XML_TEMPLATE);
          })
          .catch(() => {
            setXmlTemplate(DEFAULT_XML_TEMPLATE);
          })
          .finally(() => setMigrating(false));
      }
    }
  }, [presetData]);

  const handleSave = () => {
    if (!id.trim()) {
      alert('Preset ID is required');
      return;
    }
    onSave(id, { name, description, xml_template: xmlTemplate });
  };

  const inputStyle = { padding: '6px 8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '13px' };
  const labelStyle = { fontSize: '13px', fontWeight: 'bold', marginBottom: '4px' };
  const sectionStyle = { marginBottom: '16px', padding: '12px', background: '#f9f9f9', borderRadius: '6px', border: '1px solid #eee' };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'flex-start',
      paddingTop: '20px', zIndex: 1000, overflowY: 'auto',
    }}>
      <div style={{
        background: 'white', borderRadius: '8px', padding: '24px', width: '900px',
        maxHeight: '94vh', overflowY: 'auto', boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        marginBottom: '20px',
      }}>
        <h3 style={{ marginTop: 0 }}>{isNew ? 'New Preset' : `Edit Preset: ${presetId}`}</h3>

        {/* Basic info */}
        <div style={sectionStyle}>
          {isNew && (
            <div style={{ marginBottom: '8px' }}>
              <label style={labelStyle}>Preset ID</label>
              <input value={id} onChange={(e) => setId(e.target.value)} style={{ ...inputStyle, width: '100%' }} placeholder="e.g. standard_with_source" />
            </div>
          )}
          <div style={{ marginBottom: '8px' }}>
            <label style={labelStyle}>Name</label>
            <input value={name} onChange={(e) => setName(e.target.value)} style={{ ...inputStyle, width: '100%' }} />
          </div>
          <div>
            <label style={labelStyle}>Description</label>
            <input value={description} onChange={(e) => setDescription(e.target.value)} style={{ ...inputStyle, width: '100%' }} />
          </div>
        </div>

        {/* XML Editor */}
        {migrating ? (
          <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
            Converting mapping to XML template...
          </div>
        ) : (
          <ADFXmlEditor
            xmlTemplate={xmlTemplate}
            onChange={setXmlTemplate}
          />
        )}

        {/* Actions */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
          <button onClick={onClose} style={{ padding: '8px 16px' }}>Cancel</button>
          <button onClick={handleSave} className="btn-primary" style={{ padding: '8px 16px' }}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default PresetEditor;
